import { apiService } from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import type {
  CreateShareParams,
  PublicShareResponse,
  ShareLinkResponse,
} from "@/types";

export const useCreateShareLink = () =>
  useMutation<ShareLinkResponse, unknown, CreateShareParams>({
    mutationFn: (params) =>
      apiService.post<ShareLinkResponse, CreateShareParams>("/shares", params),
    onError: () => {
      toast.error("Failed to create share link");
    },
  });

export const usePublicShare = (token?: string) =>
  useQuery<PublicShareResponse>({
    queryKey: ["public-share", token],
    enabled: !!token,
    queryFn: () => apiService.get<PublicShareResponse>(`/public/shares/${token}`),
    retry: false,
  });
